import axios, { AxiosResponse } from 'axios';

import { env } from '../../../config';
import { Order } from '../types';

export function getSiteStatusTickets(
  refPrestationPrise: string,
  currentPage: number,
  pageSize: number
) {
  return axios.get(`${env.API_URL}/dataraccov2/ordersTickets`, {
    params: {
      refPrestationPrise,
      currentPage: currentPage * pageSize,
      pageSize: pageSize
    }
  });
}

export function fetchOrders(
  buildingId: string,
  building: string[],
  stair: string[],
  floor: string[],
  serviceTakenReference: string[],
  hexacleAddress: string
): Promise<AxiosResponse<Order[]>> {
  return axios.get(`${env.API_URL}/dataraccov2/orders`, {
    params: {
      buildingId,
      building,
      stair,
      floor,
      serviceTakenReference,
      hexacleAddress
    }
  });
}
